import { useState, type ReactNode } from 'react';
import { AppBar, Box, Drawer, Toolbar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { AgronodButtonIcon, AgronodTypography } from '@agronod/mui-components';
import SideMenu from './SideMenu';

const DRAWER_WIDTH = 280;

/**
 * Applayout med sidomeny (ersätter den tidigare toppraden): permanent
 * meny på desktop, hamburgare + tillfällig meny på mindre skärmar.
 */
const AppLayout = ({ children }: { children: ReactNode }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const closeMobile = () => setMobileOpen(false);

  return (
    <Box sx={{ display: 'flex', minHeight: '100dvh' }}>
      <Box
        component="nav"
        sx={{ width: { md: DRAWER_WIDTH }, flexShrink: { md: 0 } }}
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={closeMobile}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', md: 'none' },
            // Transparent paper så menyns rundade högerkant syns
            // (samma utseende som datadelning-webs AsideNavigation).
            '& .MuiDrawer-paper': {
              width: DRAWER_WIDTH,
              border: 'none',
              backgroundColor: 'transparent',
              boxShadow: 'none',
            },
          }}
        >
          <SideMenu onNavigate={closeMobile} />
        </Drawer>
        <Drawer
          variant="permanent"
          open
          sx={{
            display: { xs: 'none', md: 'block' },
            '& .MuiDrawer-paper': {
              width: DRAWER_WIDTH,
              border: 'none',
              backgroundColor: 'transparent',
            },
          }}
        >
          <SideMenu />
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          minWidth: 0,
          backgroundColor: theme.palette.background.page,
        })}
      >
        <AppBar
          position="static"
          color="inherit"
          elevation={0}
          sx={{
            display: { md: 'none' },
            backgroundColor: 'background.paper',
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Toolbar>
            <AgronodButtonIcon
              edge="start"
              aria-label="Öppna menyn"
              onClick={() => setMobileOpen(true)}
              sx={{ mr: 1 }}
            >
              <MenuIcon />
            </AgronodButtonIcon>
            <AgronodTypography variant="h6" sx={{ fontWeight: 600 }}>
              Agrosfär Verifiering
            </AgronodTypography>
          </Toolbar>
        </AppBar>
        {children}
      </Box>
    </Box>
  );
};

export default AppLayout;
